import { render } from "./ProjectViewSummary.vue?vue&type=template&id=2de50021&scoped=true"
import script from "./ProjectViewSummary.vue?vue&type=script&lang=js"
export * from "./ProjectViewSummary.vue?vue&type=script&lang=js"

import "./ProjectViewSummary.vue?vue&type=style&index=0&id=2de50021&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de50021"]])

export default __exports__